import React from 'react';
import { FileText } from 'lucide-react';

// Live mock of the payslip / PDF-letter header exactly as reportlab prints it:
// logo scaled proportionally into a 1.4in × 0.5in box, centred; company name 18pt; address 9pt grey; title 14pt.
// 1in ≈ 64px here, so the proportions match the A4 output.
export function PayslipHeaderPreview({ companyName, companyAddress, logoUrl }) {
  const month = new Date().toLocaleDateString('en-MY', { month: 'long', year: 'numeric' });
  return (
    <div data-testid="payslip-header-preview">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-medium text-slate-700 dark:text-slate-300 flex items-center gap-1.5">
          <FileText className="h-4 w-4 text-emerald-500" /> Payslip header preview
        </p>
        <span className="text-[11px] text-slate-500">Live · updates as you type or change the logo</span>
      </div>
      {/* Always white: PDFs print on white paper regardless of app theme (inline bg beats the .dark .bg-white override) */}
      <div className="rounded-lg border border-slate-300 dark:border-slate-600 shadow-sm px-6 pt-5 pb-4" style={{ fontFamily: 'Helvetica, Arial, sans-serif', background: '#ffffff', color: '#0f172a' }}>
        {logoUrl ? (
          <div className="mx-auto mb-2 flex items-center justify-center" style={{ width: 90, height: 32 }}>
            <img src={logoUrl} alt="Company logo as printed" className="max-w-full max-h-full object-contain" data-testid="payslip-preview-logo" />
          </div>
        ) : (
          <div className="mx-auto mb-2 flex items-center justify-center rounded border border-dashed border-slate-300 text-[9px] text-slate-400" style={{ width: 90, height: 32 }} data-testid="payslip-preview-no-logo">
            no logo
          </div>
        )}
        <p className="text-center font-bold leading-tight" style={{ fontSize: 18, color: '#0f172a' }} data-testid="payslip-preview-company">
          {companyName || 'Company Name'}
        </p>
        {companyAddress ? (
          <p className="text-center mt-0.5" style={{ fontSize: 9, color: '#64748b' }}>{companyAddress}</p>
        ) : null}
        <p className="text-center font-semibold mt-3" style={{ fontSize: 14, color: '#334155' }}>Payslip for {month}</p>
        <div className="mt-4 grid grid-cols-[2fr_5fr] gap-y-1" style={{ fontSize: 10 }}>
          <span className="font-bold">Employee Name:</span><span style={{ color: "#64748b" }}>Sample Employee</span>
          <span className="font-bold">Employee ID:</span><span style={{ color: "#64748b" }}>EMP000001</span>
          <span className="font-bold">Department:</span><span style={{ color: "#64748b" }}>Human Resources</span>
        </div>
        <div className="mt-3 grid grid-cols-[3fr_1.5fr_0.3fr_3fr_1.5fr] text-white font-bold" style={{ fontSize: 9 }}>
          <span className="px-2 py-1" style={{ background: '#334155' }}>EARNINGS</span>
          <span style={{ background: '#334155' }} />
          <span />
          <span className="px-2 py-1" style={{ background: '#334155' }}>DEDUCTIONS</span>
          <span style={{ background: '#334155' }} />
        </div>
        <p className="text-center mt-2 tracking-widest" style={{ fontSize: 9, color: "#cbd5e1" }}>· · ·</p>
      </div>
      <p className="text-[11px] text-slate-500 mt-2">
        The logo is fitted proportionally into a 1.4&nbsp;in × 0.5&nbsp;in box, so wide landscape logos print largest; square or tall logos are shrunk to 0.5&nbsp;in high.
      </p>
    </div>
  );
}
